/**
 * The deployment's facts could not be read, so nothing that depends on them
 * can be shown. Said plainly, with a retry and no alternative path (ADR-0005
 * "Failure modes").
 */
export function Unavailable({ onRetry }: { onRetry: () => void }) {
  return (
    <main>
      <h1>Karvstokk is unavailable</h1>
      <p>We couldn't reach our service. Please try again in a moment.</p>
      <button type="button" onClick={onRetry}>
        Try again
      </button>
    </main>
  );
}
